import { Component, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HealthService } from '../../services/health/health.service';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
})
export class MaintenancePageComponent implements OnInit {
  message: SafeHtml | string | null = null;

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private healthService: HealthService
  ) {}

  ngOnInit() {
    this.healthService
      .isHealthy()
      .subscribe((response: { healthy: boolean; message?: string }) => {
        if (response?.healthy === true) {
          this.router.navigateByUrl('/');
        } else {
          this.message = this.sanitizer.sanitize(SecurityContext.HTML, response?.message || '');
        }
      });
  }
}
